import { EUsageThresholdSeverityTier } from "@frontend-shared/types";
import { resolveUsageThresholdSeverityTier } from "@frontend-shared/utils";

import type { IUsageThresholdSeverityStyles } from "../types";

// NOTE: Maps the shared severity tier onto an escalating visual treatment so the
// card reads its urgency at a glance: amber (80) → orange (90) → red (95) →
// hard-stop destructive (100). Colors ship a `dark:` variant to stay legible in
// both themes.
export const resolveUsageThresholdSeverity = (
  threshold: number,
): IUsageThresholdSeverityStyles => {
  const tier = resolveUsageThresholdSeverityTier(threshold);

  if (tier === EUsageThresholdSeverityTier.LIMIT_REACHED) {
    return {
      iconWrapperClassName: "bg-destructive/10 text-destructive",
      meterFillClassName: "bg-destructive",
      isLimitReached: true,
    };
  }

  if (tier === EUsageThresholdSeverityTier.CRITICAL) {
    return {
      iconWrapperClassName: "bg-red-500/10 text-red-600 dark:text-red-500",
      meterFillClassName: "bg-red-500",
      isLimitReached: false,
    };
  }

  if (tier === EUsageThresholdSeverityTier.ELEVATED) {
    return {
      iconWrapperClassName:
        "bg-orange-500/10 text-orange-600 dark:text-orange-500",
      meterFillClassName: "bg-orange-500",
      isLimitReached: false,
    };
  }

  return {
    iconWrapperClassName: "bg-amber-500/10 text-amber-600 dark:text-amber-500",
    meterFillClassName: "bg-amber-500",
    isLimitReached: false,
  };
};
